(() => {
  // Enhance only this confirmed campaign; future offers keep their own wording.
  const selector = '.ahlGiftBnrHld[id="ahlGiftBnr10513418_866833"]';
  const warmed = new Map();
  const queue = [];
  let active = 0;
  function drain() {
    while (active < 4 && queue.length) {
      const src = queue.shift();
      const image = new Image();
      image.decoding = 'async';
      image.fetchPriority = 'low';
      warmed.set(src,image);
      active++;
      const done = () => { active--; drain(); };
      image.onload = () => { image.decode().catch(() => {}).finally(done); };
      image.onerror = done;
      image.src = src;
    }
  }
  function warmGiftImages() {
    const groups = [...document.querySelectorAll('#ahlGiftPop10513418_866833 .ahlGiftPopVarInfoHld')].map(element => {
      try { return JSON.parse(element.textContent); } catch { return []; }
    });
    // Prioritize the first few choices of each gift before the longer bow list.
    const choices = groups.flatMap(group => group.slice(0,5)).concat(groups.flatMap(group => group.slice(5)));
    choices.slice(0,61).forEach(choice => {
      const src = choice.featured_image;
      if (!src || warmed.has(src) || queue.includes(src)) return;
      try { if (new URL(src,location.href).hostname !== 'cdn.shopify.com') return; } catch { return; }
      queue.push(src);
    });
    drain();
  }
  // No extra image downloads on initial page load. Warm only after gift engagement.
  document.addEventListener('click',event => {
    if (event.target.closest?.('.product-form-buttons button[name="add"],.ahlGiftWdgIcnHldAll,.ahlGiftPopBtnNxt')) warmGiftImages();
  },true);
  document.addEventListener('focusin',event => {
    if (event.target.matches?.('#ahlGiftPop10513418_866833 select')) warmGiftImages();
  });
  let placementPending = false;
  function scheduleGiftPlacement() {
    if (!location.pathname.startsWith('/products/') || placementPending) return;
    placementPending = true;
    requestAnimationFrame(() => {
      placementPending = false;
      const timeline = document.querySelector('.xbEdd');
      const banner = document.querySelector(selector);
      if (timeline && banner && timeline.nextElementSibling !== banner) timeline.after(banner);
      document.querySelectorAll('.product-form-buttons.fr-gift-form').forEach(form => {
        if (!form.querySelector('.ahlGiftBnrHld')) form.classList.remove('fr-gift-form');
      });
    });
  }
  function enhance(root) {
    scheduleGiftPlacement();
    const popupSelector = '#ahlGiftPop10513418_866833';
    const popups = root.matches?.(popupSelector) ? [root] : [...root.querySelectorAll(popupSelector)];
    popups.forEach(popup => {
      const heading = popup.querySelector('.ahlGiftPopTitle');
      const subtitle = popup.querySelector('.ahlGiftPopSubTitle');
      if (heading) heading.textContent = 'Choose your free gift';
      if (subtitle) subtitle.textContent = 'Select your complimentary gift below.';
      // Retain the app's loading animation and all click handlers.
      const label = popup.querySelector('.ahlGiftPopBtnHld');
      if (label) {
        const walker = document.createTreeWalker(label,NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) if (walker.currentNode.textContent.trim() === 'Claim Gift') walker.currentNode.textContent = 'Add my free gift';
      }
    });
    const banners = root.matches?.(selector) ? [root] : [...root.querySelectorAll(selector)];
    banners.forEach(banner => {
      banner.classList.add('fr-gift-editorial');
      const title = banner.querySelector('.ahlGiftBnrTitle');
      if (title && !banner.querySelector('.fr-gift-description')) {
        title.textContent = 'One dress + 1 free gift';
        const eyebrow = document.createElement('p');
        eyebrow.className = 'fr-gift-eyebrow';
        eyebrow.textContent = 'Free gift with purchase';
        title.before(eyebrow);
        const description = document.createElement('p');
        description.className = 'fr-gift-description';
        description.textContent = 'Choose your free gift after adding a dress to your bag.';
        title.after(description);
      } else if (title) {
        title.textContent = 'One dress + 1 free gift';
        const eyebrow = banner.querySelector('.fr-gift-eyebrow');
        if (eyebrow) eyebrow.textContent = 'Free gift with purchase';
        const description = banner.querySelector('.fr-gift-description');
        if (description) description.textContent = 'Choose your free gift after adding a dress to your bag.';
      }
      const form = banner.closest('.product-form-buttons');
      if (form) form.classList.add('fr-gift-form');
      const preview = banner.querySelector('.ahlGiftBnrPrdTiersHld');
      const arrows = banner.querySelector('.ahlGiftBnrBtnsHld');
      if (preview && arrows && arrows.parentElement !== preview) preview.append(arrows);
      if (preview && !banner.querySelector('.fr-gift-dots')) {
        const slides = [...preview.querySelectorAll('.ahlGiftBnrPrdHldIn')];
        const dots = document.createElement('div');
        dots.className = 'fr-gift-dots';
        dots.setAttribute('role','img');
        slides.forEach(slide => {
          const dot = document.createElement('span');
          dot.setAttribute('aria-hidden','true');
          dots.append(dot);
          const path = slide.querySelector('.ahl_gift_prdUrl')?.value || '';
          const label = slide.querySelector('.ahlGiftBnrPrdTitle span');
          if (label) label.textContent = path.includes('luxury-satin') ? 'Satin Hair Bow' : path.includes('super-fairy') ? 'Butterfly Tassel Hairpin' : 'Butterfly Flower Hairpin';
        });
        preview.after(dots);
        const update = () => {
          let index = slides.findIndex(slide => slide.dataset.show === '1');
          if (index < 0) index = slides.findIndex(slide => parseFloat(slide.style.left) === 0);
          if (index < 0) return;
          [...dots.children].forEach((dot,i) => dot.classList.toggle('is-active',i === index));
          dots.setAttribute('aria-label',`Gift ${index + 1} of ${slides.length}`);
        };
        update();
        // The app signals the completed slide, avoiding work on each animation frame.
        new MutationObserver(update).observe(preview,{subtree:true,attributes:true,attributeFilter:['data-show']});
      }
      banner.querySelectorAll('.ahlGiftBnrBtnNxt').forEach((button,index) => {
        button.setAttribute('role','button');
        button.setAttribute('tabindex','0');
        button.setAttribute('aria-label',index === 0 ? 'Previous gift' : 'Next gift');
        if (!button.dataset.frKeyboard) {
          button.dataset.frKeyboard = 'true';
          button.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); button.click(); }
          });
        }
      });
    });
  }
    function removeFloatingLauncher(root = document) {
    const floatingSelector = '.ahlGiftWdgIcnHldAll, #ahlGiftWdgIcnHld, .ahlGiftWdgHld, .ahlGiftWidgetHld, .ahlGiftWdgIcn, [class*="ahlGiftWdg"], [id*="ahlGiftWdg"]';
    try {
      if (root.matches?.(floatingSelector)) root.remove();
      root.querySelectorAll?.(floatingSelector)?.forEach(el => el.remove());
    } catch (e) {}
  }
  removeFloatingLauncher(document);
  enhance(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) { removeFloatingLauncher(node); enhance(node); }
  }))).observe(document.body,{childList:true,subtree:true});
})();
